<template>
  <KeepAlive>
    <component
      :show="true"
      :is="Dialog"
      @close="partial.unmount()"
    ></component>
  </KeepAlive>
</template>

<script setup>
import { usePartial } from '@/partial';
import { computed, defineAsyncComponent } from 'vue';

const props = defineProps({
  component: {
    type: String,
    required: true,
  },
});

const partial = usePartial();

const Dialog = computed(() => {
  if (!props.component) return;

  const [root, path] = props.component.split(':');

  switch (root) {
    case 'Admin':
      // return require(`Admin/Dialogs/${path}`).default
      return defineAsyncComponent(() => import(`Admin/Dialogs/${path}.vue`));
    case 'Web':
      // return require(`Web/Dialogs/${path}`).default
      return defineAsyncComponent(() => import(`Web/Dialogs/${path}.vue`));
  }
});

</script>
